var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { align: "center" } },
    [
      _c(
        "v-flex",
        { attrs: { md10: "" } },
        [
          _c(
            "v-card",
            { staticClass: "rounded-card" },
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  staticClass: "col-md-12",
                  attrs: { "lazy-validation": "" },
                  model: {
                    value: _vm.isFormValid,
                    callback: function($$v) {
                      _vm.isFormValid = $$v
                    },
                    expression: "isFormValid"
                  }
                },
                [
                  _c(
                    "v-container",
                    { attrs: { "grid-list-md": "", "text-xs-center": "" } },
                    [
                      _c("StepTitle", [_vm._v("Seleccionar Códigos")]),
                      _c(
                        "v-layout",
                        { attrs: { wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs10: "", sm10: "", md10: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value:
                                      "required|max:80|AlertaNombreUnicoCrear",
                                    expression:
                                      "'required|max:80|AlertaNombreUnicoCrear'"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.nombre.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.nombre.id
                                  ),
                                  "data-vv-name": _vm.formFields.nombre.id,
                                  counter: 80,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.nombre.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.nombre,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.nombre.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            {
                              attrs: {
                                xs2: "",
                                sm2: "",
                                md2: "",
                                "align-end": ""
                              }
                            },
                            [
                              _c("v-checkbox", {
                                attrs: {
                                  label: _vm.formFields.esAcumulable.label,
                                  "data-vv-name":
                                    _vm.formFields.esAcumulable.id,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.esAcumulable.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.esAcumulable,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.esAcumulable.value"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-layout",
                        { attrs: { wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            [
                              _c("AsociarTiposActividad", {
                                attrs: {
                                  readonly: _vm.modoVer,
                                  esEditar: _vm.esEditar
                                },
                                model: {
                                  value: _vm.idsTipoActividad,
                                  callback: function($$v) {
                                    _vm.idsTipoActividad = $$v
                                  },
                                  expression: "idsTipoActividad"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c("br"),
                      _c("br"),
                      _c(
                        "v-layout",
                        { attrs: { wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            [
                              _c("AsociarDispositivos", {
                                attrs: {
                                  readonly: _vm.modoVer,
                                  esEditar: _vm.esEditar
                                },
                                model: {
                                  value: _vm.idsDispotivo,
                                  callback: function($$v) {
                                    _vm.idsDispotivo = $$v
                                  },
                                  expression: "idsDispotivo"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }